import { AuthService } from 'src/app/services/auth.service';
import { Component } from '@angular/core';
import { CoreService } from './services/core.service';
import { Title } from '@angular/platform-browser';
import { STORAGE_KEY } from './shared/constants';
import { Router } from '@angular/router';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    standalone: false
})
export class AppComponent {
  constructor(
    private coreService: CoreService, 
    private titleService: Title,
    private router: Router,
    private authService: AuthService) {
    // set title for tab on browser
    this.titleService.setTitle('Tinglysninger');
    this.coreService.initTranslate();
    // sign out multiple tab
    window.addEventListener('storage', (event) => {
      if (event.storageArea == localStorage) {
        if (localStorage.getItem(STORAGE_KEY.APP_ID) === null) {
          this.authService.signOut();
          this.router.navigateByUrl("");
        }
      }
    });
  }
}
